module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rfore"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0006#fore"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Hasia R. Diner")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rintro"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0007#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Aaron S. Gross")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0008#pt01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HISTORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0009#ch01"
    }
  }, [_vm._v("Introduction to Part 1")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jody Myers")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0010#ch02"
    }
  }, [_vm._v("1. Food in the Biblical Era")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Elaine Adler Goodfriend")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0011#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Food in the Rabbinic Era")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("David C. Kraemer")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0012#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Food in the Medieval Era")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jonathan Brumberg-Kraus")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch05"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0013#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Food in the Modern Era")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jody Myers")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt02"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0014#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FOOD")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CULTURE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch06"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0015#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jordan D. Rosenblum")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch07"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0016#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Brief History of Jews and Garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jordan D. Rosenblum")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch08"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0017#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Jewish, Christian, and Islamic Perspectives on Food and Jewishness")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("David M. Freidenreich")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch09"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0018#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. How Ancient Greeks, Romans, Jews, and Christians Drank Their Wine")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Susan Marks")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0019#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Jews, Schmaltz, and Crisco in the Age of Industrial Food")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Rachel B. Gross")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0020#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Search for Religious Authenticity and the Case of Passover Peanut Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Zev Eleff")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0021#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. How Shabbat Cholent Became a Secular Hungarian Favorite")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Katalin Franciska Rac")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt03"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0022#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ETHICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0023#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to Part 3")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Aaron S. Gross")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0024#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Jewish Ethics and Morality in the Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jennifer A. Thompson")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0025#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Ecological Ethics in the Jewish Community Farming Movement")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Adrienne Krone")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0026#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Bloodshed and the Ethics and Theopolitics of the Jewish Dietary Laws")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Daniel H. Weiss")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch17"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0027#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Virtues of Keeping Kosher")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Elliot Ratzman")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch18"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0028#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Jewish Ethics, the Kosher Industry, and the Fall of Agriprocessors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Moses Pava")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0029#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. A Satisfying Eating Ethic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jonathan K. Crane")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch20"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0030#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Ethics of Eating Animals")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Aaron S. Gross")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "raft"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0031#aft",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jonathan Safran Foer")]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "racknow"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0032#acknow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rab_eds"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0033#ab_eds",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rab_contrib"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0034#ab_contrib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyugross0035#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f43bad4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nyugross0005.vue
// module id = 66
// module chunks = 0